import { ArrowUpRight } from "lucide-react";
import { ZEFFY_URL } from "@/lib/site";

export default function DonateButton({ variant = "gold", className = "", children, testid = "donate-button" }) {
  const styles = {
    gold: "bg-gold text-forest hover:bg-golddark hover:shadow-xl",
    outlineLight: "border border-ivory/70 text-ivory hover:bg-ivory hover:text-forest",
    outlineDark: "border border-forest/40 text-forest hover:bg-forest hover:text-ivory",
    big: "bg-gold text-forest hover:bg-golddark hover:shadow-2xl text-lg px-10 py-5",
  };
  return (
    <a
      href={ZEFFY_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      className={`group inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 text-sm font-semibold uppercase tracking-[0.18em] transition-all duration-300 hover:scale-[1.02] ${styles[variant]} ${className}`}
    >
      {children || "Donate"}
      <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
    </a>
  );
}
